// extracted by mini-css-extract-plugin
export default {"container":"skills_container__q7esK","skill":"skills_skill__h2clq","skillContainer":"skills_skillContainer__CK3hG"};